import sessionsBlockIcon from './sessions-block.png'

export type SessionsBlockIconTone = 'primary' | 'muted' | 'live'

export interface SessionsBlockIconProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  size?: number | string
  tone?: SessionsBlockIconTone
}

const toneStyles: Record<SessionsBlockIconTone, React.CSSProperties> = {
  primary: {},
  muted: {
    filter: 'grayscale(1) opacity(0.5)',
  },
  live: {
    filter:
      'brightness(0) saturate(100%) invert(32%) sepia(86%) saturate(456%) hue-rotate(123deg) brightness(94%) contrast(93%)',
  },
}

export const SessionsBlockIcon = ({
  size = '1.5rem',
  tone = 'primary',
  alt = '',
  style,
  ...props
}: SessionsBlockIconProps) => (
  <img
    src={sessionsBlockIcon}
    alt={alt}
    width={size}
    height={size}
    style={{
      display: 'block',
      objectFit: 'contain',
      ...toneStyles[tone],
      ...style,
    }}
    {...props}
  />
)

export default SessionsBlockIcon
